class CustomVideoControls extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.playPauseBtn = this.querySelector('.js-custom-play-pause');
    this.progressBar = this.querySelector('.js-custom-progress');
    this.progressFilled = this.querySelector('.js-custom-progress-filled');
    this.playIcon = this.querySelector('.icon-play');
    this.pauseIcon = this.querySelector('.icon-pause');
  }

  connectedCallback() {
    const wrapper = this.closest('.js-video-wrapper') || this.parentElement;
    this.video = wrapper.querySelector('video');

    if (!this.video) return;

    this.initEvents();
  }

  initEvents() {
    // Play/Pause button click
    if (this.playPauseBtn) {
      this.playPauseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      });
    }

    // Progress bar click to seek
    if (this.progressBar) {
      this.progressBar.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const rect = this.progressBar.getBoundingClientRect();
        const pos = (e.clientX - rect.left) / this.progressBar.offsetWidth;
        this.video.currentTime = pos * this.video.duration;
      });
    }

    // Video events to update UI
    this.video.addEventListener('play', this.updatePlayState.bind(this));
    this.video.addEventListener('pause', this.updatePlayState.bind(this));
    this.video.addEventListener('timeupdate', this.updateProgress.bind(this));
    this.video.addEventListener('loadedmetadata', this.updateProgress.bind(this));
  }

  updatePlayState() {
    if (!this.playPauseBtn) return;
    
    if (this.video.paused) {
      if (this.playIcon) this.playIcon.classList.remove('hidden');
      if (this.pauseIcon) this.pauseIcon.classList.add('hidden');
    } else {
      if (this.playIcon) this.playIcon.classList.add('hidden');
      if (this.pauseIcon) this.pauseIcon.classList.remove('hidden');
    }
  }

  updateProgress() {
    if (!this.video.duration || !this.progressFilled) return;
    const progressPercent = (this.video.currentTime / this.video.duration) * 100;
    this.progressFilled.style.width = `${progressPercent}%`;
  }
}

if (!customElements.get('custom-video-controls')) {
  customElements.define('custom-video-controls', CustomVideoControls);
}
